<template>
  <div
    class="information-text-block d-flex flex-column ga-3"
    data-qa="lpu_information_text_block"
  >
    <h3 class="text-subtitle-1 text--text">
      {{ title }}
    </h3>
    <div
      class="information-text-block__html text-body-2 text--text text-break"
      v-html="html/* eslint-disable-line vue/no-v-html */"
    />
  </div>
</template>

<script lang="ts" setup>
/**
 * Текстовый блок секции «Информация».
 *
 * Разметка приходит из CMS, не из пользовательского ввода.
 */
defineProps<{
  title: string
  html: string
}>()
</script>

<style scoped lang="scss">
.information-text-block {
  min-width: 0;

  &__html {
    :deep(p) {
      margin: 0;
    }

    :deep(p + p) {
      margin-top: 8px;
    }
  }
}
</style>
